module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-banner', {
    attrs: {
      "image": 'src/assets/images/' + _vm.image
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.contact.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.contact.about'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.contact.location.title')))]), _vm._v(" "), _c('v-layout', {
    staticClass: "row wrap mt-2"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "lg8": ""
    }
  }, [_c('gmap-map', {
    staticStyle: {
      "height": "300px !important"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        scrollwheel: false
      },
      "zoom": 14
    }
  }, _vm._l((_vm.markers), function(m) {
    return _c('gmap-marker', {
      key: m,
      attrs: {
        "position": m.position,
        "clickable": false,
        "draggable": false
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('h2', [_c('strong', [_vm._v(_vm._s(_vm.contact.company))])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('pages.contact.location.street')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('pages.contact.location.city')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('pages.contact.location.country')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.contact.phone))]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.contact.email
    }
  }, [_vm._v(_vm._s(_vm.contact.email))])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "href": _vm.contact.www,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.contact.www))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d00cb45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 435
// module chunks = 0